<template>
  <fo-layout>
    <span slot="alt" v-if="headlineText[1]">{{headlineText[1].sub_title}}</span>
    <span slot="title" v-if="headlineText[1]">{{headlineText[1].title}}</span>
    <div class="major-content">
      <a-row>
        <a-col :span="4">
          <div class="event-times">
            <ul>
              <li @click="clickSapn(item)"
              :class="item.data === clickData ? 'sele' : ''"
              v-for="(item, i) in navigatioData"
              :key="i">{{item.data}}</li>
            </ul>
          </div>
        </a-col>
        <a-col :sm="20">
          <a-spin :spinning="readItemsLoading">
            <div v-if="!eventData.length" class="pt-50">
              <fo-nodata ></fo-nodata>
            </div>
            <div v-else class="event-scroll">
              <a-row :gutter="50">
                <a-col :sm="8" v-for="(item, i) in eventData" :key="i">
                  <div class="card-item">
                    <div class="title to-1">
                      <span>{{item.event_month}}月</span>
                    </div>
                    <div class="info">
                      <p>{{item.event_content}}</p>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-spin>
        </a-col>
      </a-row>
    </div>
  </fo-layout>
</template>
<script type="text/javascript">
export default {
  data () {
    return {
      // 保存企业数据
      eventData: [],
      // 企业查询状态
      readItemsLoading: false,
      // 标题数据
      headlineText: [],
      // 企业查询条件
      eventCond: {
        // 第几页
        page_num: 1,
        // 每页多少条
        page_size: 999,
        // 关键词搜索
        keyword: '',
        // 按年搜索
        event_year: '2021',
        // 排序
        order: 'event_month'
      },
      // 保存点击时间的数据
      clickData: '2021',
      // 保存时间数据
      navigatioData: []
    }
  },
  mounted () {
    const nowYear = new Date().getFullYear()
    this.clickData = nowYear
    this.eventCond.event_year = nowYear
    for (var i = 0; i < 10; i++) {
      this.navigatioData.push({
        data: (nowYear - i)
      })
    }
    this.headlineItems()
    this.readItems()
  },
  methods: {
    /**
     * 页头、页脚公用信息查询
     */
    headlineItems () {
      this.get({
        url: 'configFind',
        data: {
          key: 'web_pages'
        }
      }, (r) => {
        if (r.code) {
          var data = JSON.parse(r.data.value)
          for (var i of data) {
            if (i.label_en === 'About Us' || i.label_zh === '关于我们') {
              this.headlineText = i.children
            }
          }
        } else {
          this.error(r.msg)
        }
      })
    },
    // 点击的年份
    clickSapn (e) {
      this.clickData = e.data
      this.eventCond.event_year = e.data
      this.readItems()
    },
    /*
    * 查询企业
    */
    readItems () {
      this.readItemsLoading = true
      this.get({
        url: 'eventRead',
        data: this.eventCond
      }, (r) => {
        this.readItemsLoading = false
        if (r.code) {
          this.eventData = r.data.items
        } else {
          this.error(r.msg)
        }
      })
    }
  }
}
</script>
<style lang="less">
  @import url('../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .major-content {
    margin-top: 50px;
    .event-times {
      width: 80px;
      font-size: 8px;
      ul {
        border-left: 2px solid @graydark;
      }
      li {
        list-style-type: none;
        margin-bottom: 40px;
        font-size: 1.8em;
        padding-left: 40px;
        position: relative;
        cursor: pointer;
        color: @silver;
        &:before {
          content: '';
          width: 20px;
          border-top: 2px solid @graydark;
          margin-top: -2px;
          position: absolute;
          left: 0;
          top: 50%;
        }
      }
      li.sele {
        color: @primary;
        &:before {
          height: 10px;
          background-color: @primary;
          border-top: none;
          margin-top: -7px;
        }
        &:after {
          content: '';
          width: 6px;
          height: 6px;
          background-color: @primary;
          margin-top: -5px;
          position: absolute;
          left: 17px;
          top: 50%;
          transform: rotate(45deg);
        }
      }
      li:hover {
        color: @primary;
      }
    }
    .event-times,
    .event-scroll {
      overflow-x: hidden;
      overflow-y: auto;
      height: 500px;
      &::-webkit-scrollbar {
        width: 0;
        background-color: rgba(0,0,0,0.1);
        border-radius: 3px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0,0,0,0.6);
        border-radius: 3px;
      }
    }
    .event-times {
      position: relative;
      z-index: 2;
    }
    .card-item {
      height: 360px;
      margin-left: 40px;
      .title {
        font-size: 2em;
        border-bottom: 1px solid @graydark;
        padding-bottom: 10px;
      }
      .info {
        margin-top: 10px;
        overflow: auto;
        line-height: 26px;
        p {
          height: 256px;
        }
        &::-webkit-scrollbar {
          width: 0;
          background-color: rgba(0,0,0,0.1);
          border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.6);
          border-radius: 3px;
        }
      }
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .major-content {
    margin-top: 50px;
    .event-times {
      ul {
        border-left: 2px solid @graydark;
      }
      li {
        list-style-type: none;
        margin-bottom: 40px;
        font-size: 1.8em;
        padding-left: 40px;
        position: relative;
        cursor: pointer;
        color: @silver;
        &:before {
          content: '';
          width: 20px;
          border-top: 2px solid @graydark;
          margin-top: -2px;
          position: absolute;
          left: 0;
          top: 50%;
        }
      }
      li.sele {
        color: @primary;
        &:before {
          height: 10px;
          background-color: @primary;
          border-top: none;
          margin-top: -7px;
        }
        &:after {
          content: '';
          width: 6px;
          height: 6px;
          background-color: @primary;
          margin-top: -5px;
          position: absolute;
          left: 17px;
          top: 50%;
          transform: rotate(45deg);
        }
      }
      li:hover {
        color: @primary;
      }
    }
    .event-times,
    .event-scroll {
      overflow-x: hidden;
      overflow-y: auto;
      height: 500px;
      &::-webkit-scrollbar {
        width: 0;
        background-color: rgba(0,0,0,0.1);
        border-radius: 3px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0,0,0,0.6);
        border-radius: 3px;
      }
    }
    .card-item {
      height: 360px;
      .title {
        font-size: 2em;
        border-bottom: 1px solid @graydark;
        padding-bottom: 10px;
      }
      .info {
        margin-top: 10px;
        overflow: auto;
        line-height: 26px;
        p {
          height: 256px;
        }
        &::-webkit-scrollbar {
          width: 0;
          background-color: rgba(0,0,0,0.1);
          border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.6);
          border-radius: 3px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/majorEvent.vue